import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Redirect,
  Switch,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import i18n from "../i18n";
import LoginScreen from "../screens/Auth/LoginScreen";
import UsersScreen from "../screens/Users/UsersScreen";
import CreateUserScreen from "../screens/Users/CreateUserScreen";
import SelectPackageScreen from "../screens/Users/SelectPackageScreen";
import GetUserCredentialsScreen from "../screens/Users/GetUserCredentialsScreen";
import DailyReportScreen from "../screens/DailyReport/DailyReportScreen";
import OrdersScreen from "../screens/Orders/OrdersScreen";
import Spinner from "../components/utils/Spinner";
import RequestCourseScreen from "../screens/Orders/RequestCourseScreen";
import AddOrderScreen from "../screens/Orders/AddOrderScreen";
import { setCenterId } from "../store/actions/centersAction";
import AddExpenses from "../screens/Orders/AddExpenses";
import { handleLoading } from "../store/actions/loadingAction";
import SideBar from "../screens/SideBar/SideBar";
import { getAccessLevels } from "../store/actions/accessLevelsAction";
import RequestedCourse from "../screens/Orders/RequestedCourse";
import CafeOrdersScreen from "../screens/Orders/CafeOrdersScreen";
import ExpensesScreen from "../screens/Orders/ExpensesScreen";
import MembershipsScreen from "../screens/DailyReport/MembershipsScreen";
import Caffetteria from "../screens/Caffetteria/Caffetteria";
import SelectBalanceScreen from "../screens/Users/SelectBalanceScreen";
import { bioLogout, executeSocketActions } from "../db/BioStar/APIs";
import CompleteBalanceScreen from "../screens/Users/CompleteBalanceScreen";
import CompleteBuyPackageScreen from "../screens/Users/CompleteBuyPackageScreen";
import { LOGOUT } from "../store/actions/authenticationAction";
import axios from "axios";

import { fetchDollarPrices } from "../store/actions/dollarPricesAction";
import i18next from "i18next";
import CourseDetailsScreen from "../screens/Orders/CourseDetailsScreen";
import RequestsScreen from "../screens/Requests/RequestsScreen";
import SwimmingItemSells from "../screens/Orders/SwimmingItemSells";
import SwimmingSaleDetails from "../screens/Orders/SwimmingSaleDetails";
import AddPhysicalTherapy from "../screens/Users/AddPhysicalTherapy";
import NutritionItemSells from "../screens/Orders/NutritionItemSells";
import NutritionSaleDetails from "../screens/Orders/NutritionSaleDetails";
import PrivateRoute from "./PrivateRoute";

const supportedLanguages = ["en", "ku"];
export const LANGUAGES = [{ id: 0, label: 'English', lang: 'en' }, { id: 1, label: 'کوردی', lang: 'ku' }, { id: 2, label: 'عربی', lang: 'ar' }]

const Routess = (props) => {
  const [isOnline, setIsOnline] = useState(true);
  let User = useSelector((state) => state.authentication.user);
  const dispatch = useDispatch();
  const pathLang = window.location.pathname.split("/")[1];
  const loading = useSelector((state) => state.loading.loading);
  let centerId = localStorage.getItem("centerId");
  const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language'))

  const languageDetect = () => {
    if (supportedLanguages.includes(pathLang)) i18n.changeLanguage(pathLang);
    else i18n.changeLanguage("ku");
  };

  useEffect(() => {
    setup();

    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  const setup = () => {
    checkCenterId();
    checkSession();
    languageDetect();
    executeSocketActions()
  };

  const checkCenterId = async () => {
    try {
      // if (centerId) {
      //   let data = JSON.parse(centerId).centerId;
      //   await setCenterId(data);
      // } else {
      await localStorage.setItem(
        "centerId",
        JSON.stringify({ centerId: "66bdca9b7add38fef2918d63" })
      );
      await setCenterId("66bdca9b7add38fef2918d63");
      // }
    } catch (e) {
      alert(e)
    }

  };

  useEffect(() => {
    if (User) {
      getData();
    }
  }, [User]);

  const onChangeLanguage = (e) => {
    setCurrentLanguage(e.target.value)
    localStorage.setItem('language', e.target.value)
    i18next.changeLanguage(e.target.value)
  }

  const getData = async () => {
    try {
      handleLoading();
      await fetchDollarPrices()
      if (User.type == 0 || User.type == 2 || User.type == 3) {
        getAccessLevels();
      }

      handleLoading();

    } catch (e) {
      if (e.response.status === 401) {
        alert('Session Expired');
      } else
        alert('something went wrong please try again later')
      bioLogout();
      LOGOUT();

    }
  };

  function changeStatus() {
    setIsOnline(navigator.onLine);
  }

  const checkSession = () => {
    let token = localStorage.getItem("Auth");
    if (!token) return;
    token = JSON.parse(token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token.token}`

    dispatch({
      type: "LOGIN",
      data: token.user,
    });
  };

  return (
    <Router>
      {!isOnline && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            zIndex: 10000000,
            position: "absolute",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(22,29,29,0.8)",
          }}>
          <h1 className='absolute pb-20 text-2xl text-white'>
            تکایە دڵنیابە لە پەیوەندیکردن بە ئینتەرنێتەوە
          </h1>
          <Spinner color='#fff' />
        </div>
      )}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            position: "absolute",
            height: "100vh",
            width: "100%",
            backgroundColor: "rgba(22,29,29,0.8)",
          }}>
          <Spinner color='#fff' />
        </div>
      )}
      <div style={{}}>
        {!User ? (
          <Switch>
            <Route exact path='/login'>
              <LoginScreen />
            </Route>
            <Route path='*'>
              <Redirect to={"/login"} />
            </Route>
          </Switch>
        ) : (
          <div style={{ fontFamily: currentLanguage === 'en' ? 'Montserrat' : 'Rudaw-Regular', overflow: "auto" }} className='flex h-screen'>
            <SideBar onChangeLanguage={onChangeLanguage} currentLanguage={currentLanguage} />
            <Switch>
              {/* <Route exact path='/users'>
                <UsersScreen />
              </Route> */}
              {/* only for owner, reception, accountant */}
              <PrivateRoute exact path="/users" component={UsersScreen} allowedRoles={[0, 2, 7]} />

              <PrivateRoute exact path="/users/create" component={CreateUserScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update" component={CreateUserScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/create/selectPackage" component={SelectPackageScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/getUserCredentials" component={GetUserCredentialsScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/create/selectPackage/getUserCredentials" component={GetUserCredentialsScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/selectPackage" component={SelectPackageScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/selectBalance" component={SelectBalanceScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/printPackage" component={CompleteBuyPackageScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/selectBalance/completeBalance" component={CompleteBalanceScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/selectPackage/getUserCredentials" component={GetUserCredentialsScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/dailyReport" component={DailyReportScreen} allowedRoles={[0, 2, 4, 7]} />
              <PrivateRoute exact path="/dailyReport/memberships" component={MembershipsScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/others" component={OrdersScreen} allowedRoles={[0, 2, 4, 7]} />
              <PrivateRoute exact path="/others/other-revenue" component={CafeOrdersScreen} allowedRoles={[0, 2, 4, 7]} />
              <PrivateRoute exact path="/others/other-revenue/:id" component={AddOrderScreen} allowedRoles={[0, 2, 4, 7]} />
              <PrivateRoute exact path="/courses" component={RequestedCourse} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/courses/:id" component={CourseDetailsScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/users/update/requestCourse" component={RequestCourseScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/others/nutrition-sales" component={NutritionItemSells} allowedRoles={[0, 4, 7]} />
              <PrivateRoute exact path="/others/nutrition-sales/add-nutrition" component={NutritionSaleDetails} allowedRoles={[0, 4, 7]} />
              <PrivateRoute exact path="/others/swimming-items" component={SwimmingItemSells} allowedRoles={[0, 4, 7]} />
              <PrivateRoute exact path="/others/swimming-items/add-swimming-item" component={SwimmingSaleDetails} allowedRoles={[0, 4, 7]} />
              <PrivateRoute exact path="/others/swimming-items/add-swimming-item" component={SwimmingSaleDetails} allowedRoles={[0, 4, 7]} />
              <PrivateRoute exact path="/cafeteria" component={Caffetteria} allowedRoles={[0, 4, 7]} />



              {/* <Route exact path='/users/physical-therapy'>
                <AddPhysicalTherapy />
              </Route> */}
              <PrivateRoute exact path="/cafeteria-card" component={CafeOrdersScreen} allowedRoles={[0, 2, 4, 7]} />
              <PrivateRoute exact path="/cafeteria-card/:id" component={AddOrderScreen} allowedRoles={[0, 2, 4, 7]} />


              <PrivateRoute exact path="/expenses" component={ExpensesScreen} allowedRoles={[0, 2, 7]} />
              <PrivateRoute exact path="/expenses/:expenseId" component={AddExpenses} allowedRoles={[0, 2, 7]} />
              {/* <PrivateRoute exact path="/cafeteria-card" component={CafeOrdersScreen} allowedRoles={[0, 2, 7]} /> */}
              {/* <PrivateRoute exact path="/cafeteria-card/:cafeId" component={AddExpenses} allowedRoles={[0, 2, 7]} /> */}


              {/* <Route exact path='/requests'>
                <RequestsScreen />
              </Route> */}
              <Route path='*'>
                <Redirect to={User?.type === 4 ? '/cafeteria' : '/users'} />
              </Route>
            </Switch>
            {/* <Route path='*'>
              <Redirect to='/cafeteria' />
            </Route> */}

          </div>
        )}
      </div>
    </Router>
  );
};

export default Routess;
